// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-first-wrapper .link:hover .gop-container[data-v-e52a281a] {\n  background-color: #d9fafa;\n}\n.slide-first-wrapper .link.active .gop-container[data-v-e52a281a] {\n  background-color: #00FFFF;\n}", ""]);
// Exports
module.exports = exports;
